<template>
  <div class="home">
    <div class="l-section section--config">
      <div class="l-section l-section__inner">
        <div class="column video-select">
          <label class="video-select__label" for="video-select__input">
            Paste YouTube video code:
          </label>
          <input class="video-select__input" v-model="currentVidId" />
        </div>
      </div>
    </div>
    <div class="l-section section--youtube">
      <div class="l-section l-section__inner">
        <YouTubePlayer ref="YTplayer" :key="currentVidId" />
      </div>
    </div>
    <div class="l-section section--pads">
      <div class="l-section l-section__inner">
        <ModPads />
        <CuePads />
        <MemoryPads />
      </div>
    </div>
  </div>
</template>

<script>
import ModPads from "@/components/ModPads.vue";
import CuePads from "@/components/CuePads.vue";
import MemoryPads from "@/components/MemoryPads.vue";
import YouTubePlayer from "@/components/YouTubePlayer.vue";

export default {
  name: "home",
  components: {
    YouTubePlayer,
    CuePads,
    MemoryPads,
    ModPads
  },
  data() {
    return {
      midiInputs: [],
      hasMidi: false
    };
  },
  computed: {
    currentVidId: {
      get: function() {
        return this.$store.state.volatile.currentVidId;
      },
      set: function(newId) {
        this.$store.dispatch("setVideo", newId);
      }
    },
    currentInput: {
      get: function() {
        return this.$store.state.volatile.currentMidiInput;
      },
      set: function(value) {
        this.setMidi(value);
      }
    }
    // midiInputs() {
    //   return this.$store.state.midiInputs;
    // }
  },
  methods: {
    ctrlDown() {
      // TODO: make this functional for Set mode
      console.log("Control down");
    }
  },
  mounted() {
    this.$store.state.config.setMode = false;
    this.$store.state.config.clearMode = false;
    setTimeout(() => {
      this.$store.dispatch("setVideo", this.$store.state.volatile.currentVidId); //  Set video from input
    }, 1000);
    // Subscribe to store updates
    this.$store.subscribe((mutation, state) => {
      // Store the state object as a JSON string // wait for all mutations and data to arrive
      setTimeout(function() {
        localStorage.setItem("volatile", JSON.stringify(state.volatile));
      }, 500);
    });
  },
  beforeCreate() {
    this.$store.commit("initializeStore");
  }
};
</script>

<style scoped lang="scss">
@import "../partials/base";

.home {
  padding-bottom: 100px;
}

.video-select {
  margin-top: 15px;
  text-align: left;
  &__label {
    display: block;
  }
  &__input {
    padding: 20px;
    font-size: 20px;
    @media (max-width: $break-small) {
      width: 100%;
    }
  }
}
</style>
